export enum AdditionalInfoSectionEnum {
  PrimaryContact = 'primary contact',
  Supervisor = 'supervisor',
  TimesheetApprover = 'timesheet approver',
}
